module.exports = __webpack_public_path__ + "0.1.0/img/ild_logo.3089fd48.png";